type Person={id:string;username?:string;displayName?:string;roleMention?:boolean};
type Span={start:number;end:number;wire:string};
export type ComposerProjection={text:string;spans:Span[]};

// Draft storage keeps stable IDs. The textarea uses readable labels and normal
// text selection; unchanged mention spans round-trip without resolving names.
export function projectComposerMentions(raw:string,people:Person[]):ComposerProjection{
 const names=new Map(people.map(p=>[p.roleMention?'&'+p.id.replace(/^role:/,''):p.id,p.roleMention?p.displayName||p.username:p.username||p.displayName]));
 const spans:Span[]=[];let text='',at=0;
 for(const match of raw.matchAll(/<@(&?[0-9a-f-]{36})>|<a?:([a-z0-9_]{2,32}):[0-9a-f-]{36}>/gi)){
  text+=raw.slice(at,match.index);
  const start=text.length; text+=match[2]?':'+match[2]+':':'@'+(names.get(match[1])||'Nutzer');
  spans.push({start,end:text.length,wire:match[0]});at=match.index+match[0].length;
 }
 return {text:text+raw.slice(at),spans};
}

export function editComposerMentions(previous:ComposerProjection,next:string):string{
 if(next===previous.text)return restore(previous.text,previous.spans);
 let prefix=0,suffix=0;
 while(prefix<previous.text.length&&prefix<next.length&&previous.text[prefix]===next[prefix])prefix++;
 while(suffix<previous.text.length-prefix&&suffix<next.length-prefix&&previous.text[previous.text.length-1-suffix]===next[next.length-1-suffix])suffix++;
 const delta=next.length-previous.text.length;
 const oldChanged=previous.text.slice(prefix,previous.text.length-suffix),newChanged=next.slice(prefix,next.length-suffix);
 const wrapped=oldChanged?newChanged.indexOf(oldChanged):-1;
 const uniqueWrap=wrapped>=0&&newChanged.indexOf(oldChanged,wrapped+1)<0;
 const spans=previous.spans.flatMap(span=>{
  const shift=span.end<=prefix?0:span.start>=previous.text.length-suffix?delta:uniqueWrap&&span.start>=prefix&&span.end<=previous.text.length-suffix?wrapped:null;
  if(shift===null)return [];
  const mapped={...span,start:span.start+shift,end:span.end+shift};
  // Extending a handle edits its recipient instead of leaving a hidden ID behind.
  const tail=next[mapped.end]||'';
  return span.wire.startsWith('<@')&&tail!==previous.text[span.end]&&/[\p{L}\p{N}_]/u.test(tail)?[]:[mapped];
 });
 return restore(next,spans);
}
function restore(text:string,spans:Span[]):string{
 for(const span of [...spans].reverse())text=text.slice(0,span.start)+span.wire+text.slice(span.end);
 return text;
}
